// extracted by mini-css-extract-plugin
export var actionsDesktop = "recipe-header-module--actions-desktop--0b074";
export var actionsMobile = "recipe-header-module--actions-mobile--10dfd";
export var container = "recipe-header-module--container--fd304";
export var counterBox = "recipe-header-module--counter-box--cfb62";
export var counterLabel = "recipe-header-module--counter-label--e11f6";
export var dotsMore = "recipe-header-module--dots-more--04b15";
export var dropdown = "recipe-header-module--dropdown--0b066";
export var dropdownButton = "recipe-header-module--dropdown-button--26688";
export var editLoading = "recipe-header-module--edit-loading--ebad6";
export var listButton = "recipe-header-module--list-button--1489e";
export var pdfButton = "recipe-header-module--pdf-button--888be";
export var planButton = "recipe-header-module--plan-button--454d2";